import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import toast, { Toaster } from 'react-hot-toast';
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight } from 'react-icons/fi';
import Logo from '../../../section/Header/Logo';
import AdminService from '../../../service/AdminService';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      setCredentials(prev => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.email || !credentials.password) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    setIsSubmitting(true);

    try {
      const { data } = await AdminService.Login(credentials);

      localStorage.setItem('admin_data', JSON.stringify(data.admin));
      localStorage.setItem('token', data.token);

      if (rememberMe) {
        localStorage.setItem('rememberedEmail', credentials.email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }

      toast.success('Connexion réussie');
      setTimeout(() => navigate('/admin'), 800);

    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Erreur de connexion';
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="hd-admin-login">
      <Toaster position="top-center" />

      <div className="hd-admin-login-glow hd-admin-login-glow-1" />
      <div className="hd-admin-login-glow hd-admin-login-glow-2" />

      <motion.div
        className="hd-admin-login-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <div className="hd-admin-login-brand">
          <Logo />
          <p className="hd-admin-login-tagline">Espace Administration</p>
        </div>

        <div className="hd-admin-login-right">
        <form className="hd-admin-login-form" onSubmit={handleSubmit}>
          <div className="hd-admin-field">
            <FiMail className="hd-admin-field-icon" />
            <input
              id="email"
              type="email"
              name="email"
              placeholder=" "
              required
              value={credentials.email}
              onChange={handleChange}
              autoComplete="email"
            />
            <label htmlFor="email">Email</label>
          </div>

          <div className="hd-admin-field">
            <FiLock className="hd-admin-field-icon" />
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder=" "
              required
              value={credentials.password}
              onChange={handleChange}
              autoComplete="current-password"
            />
            <label htmlFor="password">Mot de passe</label>
            <button
              type="button"
              className="hd-admin-field-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>

          <label className="hd-admin-remember">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Se souvenir de moi</span>
          </label>

          <motion.button
            type="submit"
            disabled={isSubmitting}
            className="hd-admin-submit"
            whileHover={!isSubmitting ? { y: -2 } : undefined}
            whileTap={!isSubmitting ? { scale: 0.98 } : undefined}
          >
            {isSubmitting ? (
              <>
                <span className="hd-admin-spinner" />
                Connexion...
              </>
            ) : (
              <>
                Se connecter
                <FiArrowRight />
              </>
            )}
          </motion.button>
        </form>

        <div className="hd-admin-login-footer">
          © {new Date().getFullYear()} Home Deco. Tous droits réservés.
        </div>
        </div>
      </motion.div>
    </div>
  );
}
